import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import {
  CyborgClassicHoodieProduct,
  CyborgClassicHoodieShopifyMap,
} from './CyborgClassicHoodieShopifyMap';
import {
  CyborgClassicLongSleeveProduct,
  CyborgClassicLongSleeveShopifyMap,
} from './CyborgClassicLongSleeveShopifyMap';
import {
  CyborgClassicTshirtBlackProduct,
  CyborgClassicTshirtBlackShopifyMap,
} from './CyborgClassicTshirtBlackShopifyMap';
import {
  CyborgClassicTshirtWhiteProduct,
  CyborgClassicTshirtWhiteShopifyMap,
} from './CyborgClassicTshirtWhiteShopifyMap';
import {
  EvolveToCyborgTshirtBlackProduct,
  EvolveToCyborgTshirtBlackShopifyMap,
} from './EvolveToCyborgTshirtBlackShopifyMap';
import {
  EvolveToCyborgTshirtWhiteProduct,
  EvolveToCyborgTshirtWhiteShopifyMap,
} from './EvolveToCyborgTshirtWhiteShopifyMap';
import {
  EvolveTshirtBlackProduct,
  EvolveTshirtBlackShopifyMap,
} from './EvolveTshirtBlackShopifyMap';
import {
  EvolveTshirtWhiteProduct,
  EvolveTshirtWhiteShopifyMap,
} from './EvolveTshirtWhiteShopifyMap';
import {
  UltraverseTshirtBlackProduct,
  UltraverseTshirtBlackShopifyMap,
} from './UltraverseTshirtBlackShopifyMap';
import {
  UltraverseTshirtWhiteProduct,
  UltraverseTshirtWhiteShopifyMap,
} from './UltraverseTshirtWhiteShopifyMap';

export const getAllMerchProducts = () => [
  CyborgClassicHoodieProduct,
  CyborgClassicLongSleeveProduct,
  CyborgClassicTshirtBlackProduct,
  CyborgClassicTshirtWhiteProduct,
  EvolveToCyborgTshirtBlackProduct,
  EvolveToCyborgTshirtWhiteProduct,
  EvolveTshirtBlackProduct,
  EvolveTshirtWhiteProduct,
  UltraverseTshirtBlackProduct,
  UltraverseTshirtWhiteProduct,
];

export const getAllMerchShopifyMaps = () => ({
  CyborgClassicHoodie: CyborgClassicHoodieShopifyMap,
  CyborgClassicLongSleeve: CyborgClassicLongSleeveShopifyMap,
  CyborgClassicTshirtBlack: CyborgClassicTshirtBlackShopifyMap,
  CyborgClassicTshirtWhite: CyborgClassicTshirtWhiteShopifyMap,
  EvolveToCyborgTshirtBlack: EvolveToCyborgTshirtBlackShopifyMap,
  EvolveToCyborgTshirtWhite: EvolveToCyborgTshirtWhiteShopifyMap,
  EvolveTshirtBlack: EvolveTshirtBlackShopifyMap,
  EvolveTshirtWhite: EvolveTshirtWhiteShopifyMap,
  UltraverseTshirtBlack: UltraverseTshirtBlackShopifyMap,
  UltraverseTshirtWhite: UltraverseTshirtWhiteShopifyMap,
});

export const getMerchProductByStore = (store: ShopifyStore) => {
  const products = getAllMerchProducts();
  const shopifyMaps = getAllMerchShopifyMaps();

  return products.map((product, index) => {
    const mapKey = Object.keys(shopifyMaps)[index] as keyof ReturnType<
      typeof getAllMerchShopifyMaps
    >;
    const shopifyMap = shopifyMaps[mapKey];
    const storeData = shopifyMap[store];

    const { availableSizes, ...productWithoutSizes } = product;

    return {
      ...productWithoutSizes,
      shopifyProductId: '', // Keep consistent with old structure
      price: storeData.price,
      size: Object.fromEntries(
        availableSizes.map((size: MerchSizes) => [
          size,
          {
            variantId: storeData.sizes[size].variantId,
            checkOutUrl: storeData.sizes[size].checkoutUrl,
          },
        ]),
      ),
    };
  });
};

export const getLegacyMerchData = (store: ShopifyStore) => {
  return {
    taxInclusive:
      store === ShopifyStore.ROW ||
      store === ShopifyStore.IN ||
      store === ShopifyStore.AE,
    products: getMerchProductByStore(store),
  };
};
